import React from 'react';
import { Dropdown as BsDropdown } from 'react-bootstrap';
import makeBranch from './makeBranch';

function DropdownMenu(props) {
  return <div {...props} />;
}

const MenuBranch = makeBranch('MenuBranch', BsDropdown.Menu, DropdownMenu);

MenuBranch.defaultProps = {
  bsRole: 'menu',
};

export default MenuBranch;
